"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const query_string_1 = require("query-string");
const react_1 = tslib_1.__importStar(require("react"));
const react_helmet_1 = tslib_1.__importDefault(require("react-helmet"));
const react_if_1 = require("react-if");
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const CenteredPage_1 = require("../CenteredPage");
const utils_1 = require("../../utils");
const context_1 = require("../../context");
const react_2 = require("@osmosys/react");
exports.OsmosysRoute = (_a) => {
    var { access = 'private', padding, centered, title, nav, navBottomPadding, navProps, collapseNav, shrink, overflow = 'hidden', mode: routeMode } = _a, routeProps = tslib_1.__rest(_a, ["access", "padding", "centered", "title", "nav", "navBottomPadding", "navProps", "collapseNav", "shrink", "overflow", "mode"]);
    centered = typeof centered === 'boolean' ? centered : false;
    padding = typeof padding === 'boolean' ? padding : false;
    const { currentUser, adminRole, mode: currentMode } = react_1.useContext(context_1.OsmosysAppContext);
    const { hasAccess, accessMessage } = react_1.useMemo(() => {
        const hasAccess = !!(access === 'all'
            ? true
            : access === 'public'
                ? !currentUser
                : access === 'private'
                    ? currentUser
                    : access === 'admin'
                        ? currentUser && currentUser.isAppAdmin && adminRole === 'app'
                        : access === 'workspaceAdmin'
                            ? adminRole === 'workspace' || adminRole === 'app'
                            : false);
        const accessMessage = hasAccess && access === 'public'
            ? 'You must be logged out to access this'
            : access === 'private'
                ? 'You must be logged in to access this'
                : access === 'admin'
                    ? 'You must be an admin to access this'
                    : access === 'workspaceAdmin'
                        ? 'You must be an admin to access this'
                        : 'You have permission to use this page, but an unknown error occurred. Please contact support for assistance.';
        return { accessMessage, hasAccess };
    }, [access, adminRole, currentUser]);
    const Comp = routeProps.component;
    const Nav = nav;
    return (react_1.default.createElement(react_router_dom_1.Route, Object.assign({}, routeProps, { component: undefined, render: RouterInner({
            access,
            accessMessage,
            centered,
            collapseNav,
            Comp,
            currentMode,
            currentUser,
            hasAccess,
            Nav,
            navBottomPadding,
            navProps,
            overflow,
            padding,
            routeMode,
            routeProps,
            shrink,
            title,
        }) })));
};
function RouterInner({ overflow, shrink, padding, centered, hasAccess, routeProps, title, collapseNav, Nav, navBottomPadding, navProps, currentMode, routeMode, access, Comp, currentUser, accessMessage, }) {
    return (props) => {
        return (react_1.default.createElement(reactstrap_1.Container, { className: utils_1.classnames('flex-full-col', 'm-0 p-0 position-relative', overflow === 'hidden' && 'overflow-hidden', shrink ? 'flex-shrink-1' : 'flex-shrink-0'), "data-padding": padding, "data-centered": centered, "data-access": hasAccess, "data-cy": "osmosys-route", tag: react_2.OsmosysDiv, osysName: "OsmosysRoute.outer", "data-route-path": routeProps.path, fluid: true },
            react_1.default.createElement(react_if_1.When, { condition: !!title }, () => react_1.default.createElement(react_helmet_1.default, { title: title })),
            !collapseNav && hasAccess && Nav && (react_1.default.createElement("div", { className: utils_1.classnames('flex-shrink-0 flex-grow-0 overflow-y-auto', padding ? 'px-2 pt-2' : 'p-2', navBottomPadding && 'pb-2 mb-4') },
                react_1.default.createElement(Nav, Object.assign({}, navProps)))),
            react_1.default.createElement(reactstrap_1.Fade, { in: true, className: utils_1.classnames('', {
                    'flex-full-col': !centered,
                    'flex-full-col-centered': centered,
                    'p-0': !padding,
                    'p-2': padding,
                }, overflow === 'hidden' && 'overflow-hidden'), "data-osmosys-comp": "OsmosysRoute.inner" },
                react_1.default.createElement(react_if_1.Switch, null,
                    react_1.default.createElement(react_if_1.Case, { condition: currentMode === 'setup' && routeMode !== 'setup' },
                        react_1.default.createElement(react_router_dom_1.Redirect, { to: "/setup" })),
                    react_1.default.createElement(react_if_1.Case, { condition: !!(access === 'public' && !hasAccess) }, () => {
                        const params = query_string_1.parse(location.search);
                        const redirect = params.redirect || '/';
                        return (react_1.default.createElement(react_router_dom_1.Redirect, { to: Array.isArray(redirect) ? redirect[0] || '/' : redirect }));
                    }),
                    react_1.default.createElement(react_if_1.Case, { condition: !!hasAccess },
                        react_1.default.createElement(Comp, Object.assign({}, props, routeProps.componentProps))),
                    react_1.default.createElement(react_if_1.Default, null,
                        react_1.default.createElement(react_if_1.If, { condition: !!currentUser },
                            react_1.default.createElement(react_if_1.Then, null, () => (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(CenteredPage_1.CenteredPage, { title: accessMessage, iconPreset: "warning", buttonText: "Go home", buttonTo: "/" })))),
                            react_1.default.createElement(react_if_1.Else, null, () => (react_1.default.createElement(react_router_dom_1.Redirect, { to: `/login${props.location.pathname.length > 1
                                    ? `?redirect=${encodeURIComponent(props.location.pathname)}`
                                    : ''}`, push: true })))))))));
    };
}
//# sourceMappingURL=OsmosysRoute.js.map